import { mainApi } from 'modules/api';
import { authCacheTags } from 'modules/auth/authCacheTags';
import { getConnectedIotaProvider } from 'modules/auth/utils/getConnectedIotaProvider';

export const {
  useGetCurrentAccountQuery,
  endpoints: { getCurrentAccount },
} = mainApi.injectEndpoints({
  endpoints: build => {
    return {
      getCurrentAccount: build.query<string | null, void>({
        queryFn: () => {
          const provider = getConnectedIotaProvider();

          try {
            const account = provider.getWalletAccount()?.address;

            return { data: account }
          } catch {
            return { data: null };
          }
        },
        providesTags: [authCacheTags.account, authCacheTags.disconnect],
      }),
    };
  },
});
